"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _InteractionEffectUtils_uuidGenerator, _InteractionEffectUtils_viewport;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionEffectUtils = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const IInteractionEffectUtils_1 = require("../../interfaces/utils/IInteractionEffectUtils");
class InteractionEffectUtils {
    constructor() {
        _InteractionEffectUtils_uuidGenerator.set(this, viewer_shared_services_1.UuidGenerator.instance);
        _InteractionEffectUtils_viewport.set(this, void 0);
    }
    get viewport() {
        return __classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f");
    }
    set viewport(value) {
        __classPrivateFieldSet(this, _InteractionEffectUtils_viewport, value, "f");
    }
    /**
     * Apply the effect material to the node and all descendants.
     *
     * @param node
     * @param material
     * @returns
     */
    applyInteractionEffect(node, effect) {
        const token = __classPrivateFieldGet(this, _InteractionEffectUtils_uuidGenerator, "f").create();
        if (!effect)
            return token;
        if ((0, IInteractionEffectUtils_1.isMaterialData)(effect)) {
            const applyEffect = (node) => {
                for (let i = 0; i < node.data.length; i++) {
                    if (node.data[i] instanceof viewer_shared_types_1.GeometryData) {
                        const geometryData = node.data[i];
                        geometryData.effectMaterials.push({
                            material: effect,
                            token,
                        });
                        geometryData.updateVersion();
                    }
                }
                for (let i = 0; i < node.children.length; i++) {
                    applyEffect(node.children[i]);
                }
            };
            applyEffect(node);
        }
        else {
            if (!__classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f"))
                return token;
            const stringified = JSON.stringify(effect);
            const postProcessingEffect = __classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f").postProcessing.outlineEffects[stringified];
            if (!postProcessingEffect)
                __classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f").postProcessing.addEffect(effect, stringified);
            __classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f").postProcessing.outlineEffects[stringified].addSelection(node);
            return stringified;
        }
        return token;
    }
    /**
     * Remove the effect material with the specified token from the node and all descendants.
     *
     * @param node
     * @param token
     */
    removeInteractionEffect(node, token) {
        const removeEffect = (node) => {
            for (let i = 0; i < node.data.length; i++) {
                if (node.data[i] instanceof viewer_shared_types_1.GeometryData) {
                    const geometryData = node.data[i];
                    const index = geometryData.effectMaterials.findIndex((e) => e.token === token);
                    if (index !== -1) {
                        geometryData.effectMaterials.splice(index, 1);
                        geometryData.updateVersion();
                    }
                }
            }
            for (let i = 0; i < node.children.length; i++) {
                removeEffect(node.children[i]);
            }
        };
        removeEffect(node);
        if (!__classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f"))
            return;
        const postProcessingEffect = __classPrivateFieldGet(this, _InteractionEffectUtils_viewport, "f").postProcessing.outlineEffects[token];
        if (postProcessingEffect)
            postProcessingEffect.removeSelection(node);
    }
}
exports.InteractionEffectUtils = InteractionEffectUtils;
_InteractionEffectUtils_uuidGenerator = new WeakMap(), _InteractionEffectUtils_viewport = new WeakMap();
//# sourceMappingURL=InteractionEffectUtils.js.map